import { render } from "./DbConnectionCard.vue?vue&type=template&id=17513cd1"
import script from "./DbConnectionCard.vue?vue&type=script&lang=js"
export * from "./DbConnectionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__